(function () {
  'use strict';

  if (window.__marlowCartDrawer) return;

  var state = {
    lastFocus: null,
    requestLocked: false,
    checkoutSubmitting: false
  };
  var overlayHistoryKey = 'marlowOverlay';
  var drawerHistoryClosing = false;

  function currentOverlay() {
    return window.history.state && window.history.state[overlayHistoryKey];
  }

  function markDrawerHistory() {
    drawerHistoryClosing = false;
    try {
      var nextState = Object.assign({}, window.history.state || {});
      nextState[overlayHistoryKey] = 'cart';
      if (currentOverlay()) {
        window.history.replaceState(nextState, '', window.location.href);
      } else {
        window.history.pushState(nextState, '', window.location.href);
      }
    } catch (error) {
      /* History can be unavailable in restricted embedded browsers. */
    }
  }

  function requestDrawerHistoryClose() {
    if (currentOverlay() !== 'cart') return false;
    if (drawerHistoryClosing) return true;
    drawerHistoryClosing = true;
    window.history.back();
    return true;
  }

  function clearStaleDrawerHistory() {
    var drawer = root();
    if (currentOverlay() !== 'cart' || (drawer && drawer.classList.contains('is-open'))) return;
    try {
      var nextState = Object.assign({}, window.history.state || {});
      delete nextState[overlayHistoryKey];
      window.history.replaceState(nextState, '', window.location.href);
    } catch (error) {
      /* History can be unavailable in restricted embedded browsers. */
    }
  }

  function root() {
    return document.querySelector('[data-marlow-cart-drawer]');
  }

  function panel() {
    var drawer = root();
    return drawer && drawer.querySelector('.marlow-cart-drawer__panel');
  }

  function focusableElements() {
    var drawerPanel = panel();
    if (!drawerPanel) return [];
    return Array.prototype.slice.call(drawerPanel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function updateCartCounts(count) {
    document.querySelectorAll('[data-marlow-cart-count]').forEach(function (badge) {
      badge.textContent = count;
      badge.hidden = count < 1;
    });
    document.querySelectorAll('[data-marlow-cart-link]').forEach(function (link) {
      link.dataset.cartCount = count;
    });
  }

  function openDrawer(preferredFocus) {
    var drawer = root();
    if (!drawer || drawer.classList.contains('is-open')) return;
    if (!state.lastFocus || !document.contains(state.lastFocus)) state.lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('marlow-cart-is-open');
    markDrawerHistory();
    var close = drawer.querySelector('.marlow-cart-drawer__close');
    window.requestAnimationFrame(function () {
      if (preferredFocus && document.contains(preferredFocus)) preferredFocus.focus();
      else if (close) close.focus();
      else if (panel()) panel().focus();
    });
  }

  function closeDrawer(fromHistory) {
    var drawer = root();
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (fromHistory !== true && requestDrawerHistoryClose()) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('marlow-cart-is-open');
    if (state.lastFocus && document.contains(state.lastFocus)) state.lastFocus.focus();
    state.lastFocus = null;
  }

  function setLoading(loading) {
    var drawer = root();
    if (!drawer) return;
    drawer.classList.toggle('is-loading', loading);
    drawer.setAttribute('aria-busy', loading ? 'true' : 'false');
    drawer.querySelectorAll('[data-marlow-cart-mutation]').forEach(function (control) {
      control.disabled = loading;
    });
  }

  function setStatus(message, isError) {
    var drawer = root();
    var status = drawer && drawer.querySelector('[data-marlow-cart-status]');
    if (!status) return;
    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError && message));
  }

  function setError(message) {
    setStatus(message, true);
  }

  function fallbackError() {
    var drawer = root();
    return drawer ? drawer.dataset.cartError : '';
  }

  function findReplacementFocus(drawer, focusContext) {
    if (!drawer || !focusContext || !focusContext.lineKey) return null;
    var lines = Array.prototype.slice.call(drawer.querySelectorAll('[data-marlow-cart-line]'));
    var line = lines.find(function (item) {
      return item.dataset.lineKey === focusContext.lineKey;
    });
    if (!line) return null;
    if (focusContext.control === 'variant') return line.querySelector('[data-marlow-cart-variant]');
    return null;
  }

  function replaceDrawer(html, shouldOpen, focusContext) {
    if (!html) return false;
    var template = document.createElement('template');
    template.innerHTML = html.trim();
    var next = template.content.querySelector('[data-marlow-cart-drawer]');
    var current = root();
    if (!next || !current) return false;
    current.replaceWith(next);
    var count = Number(next.dataset.cartCount) || 0;
    updateCartCounts(count);
    if (shouldOpen) openDrawer(findReplacementFocus(next, focusContext));
    if (focusContext && focusContext.status) setStatus(focusContext.status, false);
    return true;
  }

  function refreshDrawer(shouldOpen, focusContext) {
    var drawer = root();
    if (!drawer) return Promise.resolve();
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', drawer.dataset.sectionId);
    return fetch(url.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error(fallbackError());
        return response.text();
      })
      .then(function (html) { replaceDrawer(html, shouldOpen, focusContext); });
  }

  function sectionFromPayload(payload) {
    if (!payload) return null;
    var sections = payload.sections || {};
    return sections['marlow-cart-drawer'] || null;
  }

  function postJson(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(data)
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok) throw new Error(payload.description || payload.message || fallbackError());
        return payload;
      });
    });
  }

  function changeLine(key, quantity) {
    var drawer = root();
    if (!drawer || state.requestLocked) return;
    state.requestLocked = true;
    setLoading(true);
    setStatus('', false);

    postJson(drawer.dataset.cartChangeUrl, {
        id: key,
        quantity: quantity,
        sections: 'marlow-cart-drawer',
        sections_url: window.location.pathname
      })
      .then(function (payload) {
        var rendered = replaceDrawer(sectionFromPayload(payload), true);
        if (!rendered) return refreshDrawer(true);
      })
      .catch(function (error) {
        setError(error.message);
      })
      .finally(function () {
        state.requestLocked = false;
        setLoading(false);
      });
  }

  function parseLineProperties(line) {
    try {
      var parsed = JSON.parse(line.dataset.lineProperties || '{}');
      if (!Array.isArray(parsed)) return parsed || {};
      return parsed.reduce(function (properties, pair) {
        if (Array.isArray(pair) && pair.length > 1) properties[pair[0]] = pair[1];
        return properties;
      }, {});
    } catch (error) {
      return {};
    }
  }

  function addLinePayload(line, variantId, includeSections) {
    var item = {
      id: Number(variantId),
      quantity: Number(line.dataset.quantity) || 1,
      properties: parseLineProperties(line)
    };
    if (line.dataset.sellingPlanId) item.selling_plan = Number(line.dataset.sellingPlanId);

    var payload = { items: [item] };
    if (includeSections) {
      payload.sections = 'marlow-cart-drawer';
      payload.sections_url = window.location.pathname;
    }
    return payload;
  }

  function replacementKey(payload) {
    var items = payload && payload.items;
    return items && items[0] ? items[0].key : '';
  }

  function setVariantLoading(line, loading, message) {
    if (!line) return;
    line.classList.toggle('is-variant-loading', loading);
    var status = line.querySelector('[data-marlow-cart-variant-status]');
    if (status) status.textContent = message || '';
  }

  function replaceVariant(line, nextVariantId) {
    var drawer = root();
    var select = line && line.querySelector('[data-marlow-cart-variant]');
    if (!drawer || !line || !select) return;

    var originalVariantId = line.dataset.variantId;
    if (String(nextVariantId) === String(originalVariantId)) return;
    if (state.requestLocked) {
      select.value = originalVariantId;
      return;
    }

    var lineKey = line.dataset.lineKey;
    var removed = false;
    var updateError = null;
    var updatingMessage = drawer.dataset.variantUpdating || '';

    state.requestLocked = true;
    setVariantLoading(line, true, updatingMessage);
    setLoading(true);
    setStatus('', false);

    postJson(drawer.dataset.cartChangeUrl, {
      id: lineKey,
      quantity: 0
    })
      .then(function () {
        removed = true;
        return postJson(drawer.dataset.cartAddUrl, addLinePayload(line, nextVariantId, true));
      })
      .then(function (payload) {
        var focusContext = {
          lineKey: replacementKey(payload),
          control: 'variant',
          status: drawer.dataset.variantUpdated || ''
        };
        var rendered = replaceDrawer(sectionFromPayload(payload), true, focusContext);
        if (!rendered) return refreshDrawer(true, focusContext);
      })
      .catch(function (error) {
        if (!removed) throw error;
        updateError = error;
        return postJson(drawer.dataset.cartAddUrl, addLinePayload(line, originalVariantId, true))
          .then(
            function (rollbackPayload) {
              var rollbackContext = {
                lineKey: replacementKey(rollbackPayload),
                control: 'variant'
              };
              var rendered = replaceDrawer(sectionFromPayload(rollbackPayload), true, rollbackContext);
              var rollbackRefresh = rendered ? Promise.resolve() : refreshDrawer(true, rollbackContext);
              return rollbackRefresh.then(function () {
                throw updateError;
              });
            },
            function () {
              return refreshDrawer(true)
                .catch(function () {})
                .then(function () {
                  throw new Error(drawer.dataset.variantRestoreError || fallbackError());
                });
            }
          );
      })
      .catch(function (error) {
        setError(error.message || fallbackError());
      })
      .finally(function () {
        state.requestLocked = false;
        setVariantLoading(line, false, '');
        setLoading(false);
      });
  }

  function onDocumentClick(event) {
    var openTrigger = event.target.closest('[data-marlow-cart-open]');
    if (openTrigger) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-marlow-cart-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var line = event.target.closest('[data-marlow-cart-line]');
    if (!line) return;
    var key = line.dataset.lineKey;
    var quantity = Number(line.dataset.quantity) || 0;
    var quantityButton = event.target.closest('[data-marlow-cart-quantity]');
    var removeButton = event.target.closest('[data-marlow-cart-remove]');

    if (quantityButton) {
      event.preventDefault();
      var nextQuantity = quantityButton.dataset.marlowCartQuantity === 'plus'
        ? quantity + 1
        : Math.max(0, quantity - 1);
      changeLine(key, nextQuantity);
    } else if (removeButton) {
      event.preventDefault();
      changeLine(key, 0);
    }
  }

  function onDocumentChange(event) {
    var select = event.target.closest('[data-marlow-cart-variant]');
    if (!select) return;
    var line = select.closest('[data-marlow-cart-line]');
    if (!line) return;
    replaceVariant(line, select.value);
  }

  function onDocumentSubmit(event) {
    var form = event.target.closest && event.target.closest('[data-marlow-checkout-form]');
    if (!form) return;

    if (state.requestLocked || state.checkoutSubmitting) {
      event.preventDefault();
      return;
    }

    state.checkoutSubmitting = true;
    form.classList.add('is-submitting');
    form.setAttribute('aria-busy', 'true');

    var button = form.querySelector('[data-marlow-checkout]');
    if (!button) return;
    button.setAttribute('aria-disabled', 'true');

    // Keep the submitter enabled until Shopify has read its `name="checkout"` value.
    window.setTimeout(function () {
      button.disabled = true;
    }, 0);
  }

  function resetCheckoutState() {
    state.checkoutSubmitting = false;
    var drawer = root();
    var form = drawer && drawer.querySelector('[data-marlow-checkout-form]');
    if (!form) return;

    form.classList.remove('is-submitting');
    form.removeAttribute('aria-busy');
    var button = form.querySelector('[data-marlow-checkout]');
    if (!button) return;
    button.removeAttribute('aria-disabled');
    button.disabled = state.requestLocked;
  }

  function onKeydown(event) {
    var drawer = root();
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = focusableElements();
    if (!focusable.length) {
      event.preventDefault();
      panel().focus();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', onDocumentClick);
  document.addEventListener('change', onDocumentChange);
  document.addEventListener('submit', onDocumentSubmit);
  document.addEventListener('keydown', onKeydown);
  document.addEventListener('marlow:cart-updated', function (event) {
    var detail = event.detail || {};
    if (detail.trigger && document.contains(detail.trigger)) state.lastFocus = detail.trigger;
    var detailSections = detail.sections || {};
    var rendered = replaceDrawer(sectionFromPayload(detail.payload) || detailSections['marlow-cart-drawer'], detail.open !== false);
    if (!rendered) refreshDrawer(detail.open !== false).catch(function (error) { setError(error.message); });
  });

  document.addEventListener('shopify:section:load', function (event) {
    var drawer = event.target.querySelector('[data-marlow-cart-drawer]');
    if (drawer) updateCartCounts(Number(drawer.dataset.cartCount) || 0);
  });
  window.addEventListener('popstate', function () {
    drawerHistoryClosing = false;
    closeDrawer(true);
  });
  window.addEventListener('pageshow', function () {
    resetCheckoutState();
    clearStaleDrawerHistory();
  });

  window.__marlowCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshDrawer
  };

  var initial = root();
  if (initial) updateCartCounts(Number(initial.dataset.cartCount) || 0);
  clearStaleDrawerHistory();
})();
